import { render, staticRenderFns } from "./PlaceInfo.vue?vue&type=template&id=292f581c&scoped=true&"
import script from "./PlaceInfo.vue?vue&type=script&lang=js&"
export * from "./PlaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlaceInfo.vue?vue&type=style&index=0&id=292f581c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f581c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
